import { CaseEvidenceView } from '@/components/evidence/CaseEvidenceView'
import { SourceSnippetResult } from '@/features/source-snippets/SourceSnippetResult'
import { useCaseEvidence } from './hooks/use-case-evidence'

export function CaseEvidence({ caseId, referenceId }: { caseId: string; referenceId: string }) {
  const query = useCaseEvidence(caseId, referenceId)
  if (query.data?.snippet && !query.isError)
    return <SourceSnippetResult snippet={query.data.snippet} />
  return (
    <CaseEvidenceView
      state={{
        loading: query.isFetching || query.isPending,
        error: query.isError,
        evidence: query.data,
      }}
    />
  )
}
